import { eventNames } from 'configuration/eventNames';
import React, { useEffect, useRef, useState } from 'react';
import { firebaseAnalyticsNO } from '../../firebase';

const NameFormComponent = ({
  currentOrder,
  initiateDesktopLoyaltyFlow,
  loyalty,
  inLayoutFlow,
  firstName,
  lastName,
  fieldErrors,
  isNextDisabled,
  inputFieldBlurStatus,
  handleFirstNameChange,
  handleLastNameChange,
  handleInputFieldBlur,
  handleNameProcessNextStep,
}) => {
  const [lastNameFocused, setLastNameFocused] = useState();
  const firstNameRef = useRef();
  const lastNameRef = useRef();

  useEffect(() => {
    if (currentOrder.stage >= 1 && currentOrder.stage <= 1.1) {
      firstNameRef.current.focus();
    }
  }, [currentOrder.stage]);

  const handleKeydown = (e) => {
    if (e.keyCode === 13) {
      if (e.target.name === 'firstName') {
        lastNameRef.current.focus();
      } else if (e.target.name === 'lastName') {
        handleNameProcessNextStep(1.1);
      }
    }
  };

  return (
    <div
      className={
        currentOrder.stage >= 1 &&
        (initiateDesktopLoyaltyFlow || loyalty
          ? currentOrder.stage <= 1.1
          : currentOrder.stage <= 2)
          ? `detailsConfirm active`
          : `detailsConfirm`
      }
      style={{
        zIndex: inLayoutFlow === true ? 1001 : 1000,
      }}
    >
      <div
        className='detailsTitle  hidden-xs hidden-sm'
        style={{ marginTop: 0 }}
      >
        What’s your name?
      </div>

      <div
        className='detailsTitle visible-xs visible-sm'
        style={{ marginTop: 0 }}
      >
        What’s your name?
      </div>

      <div className='inputGroup' htmlFor='firstName'>
        <label htmlFor='firstName'>First name</label>
        <input
          id='firstName'
          autoComplete='off'
          type='text'
          name='firstName'
          className={
            fieldErrors.firstName && inputFieldBlurStatus.firstName
              ? 'error'
              : ''
          }
          value={firstName}
          onChange={handleFirstNameChange}
          ref={firstNameRef}
          onBlur={handleInputFieldBlur}
          onKeyDown={handleKeydown}
        />
      </div>

      <div className='inputGroup' htmlFor='lastName'>
        <label htmlFor='lastName'>Last name</label>
        <input
          id='lastName'
          autoComplete='off'
          type='text'
          name='lastName'
          className={
            fieldErrors.lastName && inputFieldBlurStatus.lastName ? 'error' : ''
          }
          value={lastName}
          onChange={handleLastNameChange}
          ref={lastNameRef}
          onKeyDown={handleKeydown}
          onFocus={() => setLastNameFocused(true)}
          onBlur={handleInputFieldBlur}
        />
      </div>

      <div
        className={`nextDetails${isNextDisabled ? ' disabled' : ''}`}
        onClick={() => {
          firebaseAnalyticsNO.logEvent(eventNames.ENTERED_FIRST_LAST_NAME);
          handleNameProcessNextStep(1.1);
        }}
      >
        Next
        <i className='thickcon-Right-Chevron' />
      </div>
    </div>
  );
};

export default NameFormComponent;
